module.exports = {
    checkout: {
        staffDiscountLabel: 'Team Member Discount',
        eVoucherDisplayName: 'eVoucher',
        zeroPaymentDisplayMessage: 'Your balance is less or equal to zero. Please submit your order.',
        isNewCheckoutConfirmBehavior: false,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/checkout.js